var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery"},[_vm._l((_vm.smallGallery),function(img,i){return _c('img',{key:i,attrs:{"src":img},on:{"click":_vm.openPopup}})}),(_vm.selectedImage)?_c('company-gallery-popup',{attrs:{"image":_vm.selectedImage},on:{"close":_vm.closePopup,"next":_vm.goToNext,"prev":_vm.goToPrev}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }